module.exports = __webpack_public_path__ + "static/img/homebanner_img.c0cb3f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homebanner_img.png
// module id = ZuM1
// module chunks = 1